import * as React from "react";
import Layout from "../components/xathlo/Layout";
import { HomeLink } from "../components/xathlo/HomeLink";
import { homePageRoute } from "../routes/xathlo";
import { AccountBtn } from "../components/user/AccountBtn";
import { Breadcrumbs, Container, Typography } from "@mui/material";
import { NextSeo } from "next-seo";
import { LocalDate } from "../components/common/date/LocalDate";
import { localDateStringCodec } from "../domain/common";
import { rightOrThrow } from "../utils/fp";
import { pipe } from "fp-ts/function";
import { Email } from "../components/common/Email";
import { ExternalLink } from "../components/common/Link";

// https://www.orgsu.com/privacy-policy/
export default () => {
    return (
        <Layout
            breadCrumbs={
                <Breadcrumbs>
                    <HomeLink href={homePageRoute.route({})} variant={"x"} />
                    <span>privacy</span>
                </Breadcrumbs>
            }
            rightMenu={<AccountBtn />}
        >
            <NextSeo noindex></NextSeo>
            <Container maxWidth={"md"}>
                <Typography variant={"h4"}>
                    Zásady ochrany osobních údajů xathlo.com
                </Typography>
                <Typography gutterBottom>
                    {/*Effective Date */}
                    platné od{" "}
                    <LocalDate
                        date={pipe(
                            "2024-04-08",
                            localDateStringCodec.decode,
                            rightOrThrow
                        )}
                    />
                </Typography>
                <Typography variant={"h5"}>Definice pojmů</Typography>
                <dl>
                    <dt>Provozovatel</dt>
                    <dd>
                        provozovatel aplikace xathlo.com je Patrik Pompe,
                        fyzická osoba zapsaná v živnostenském rejstříku,
                        IČO:75329093
                    </dd>

                    <dt>Uživatel</dt>
                    <dd>
                        fyzická osoba, která si v aplikaci xathlo.com vytvořila
                        uživatelský účet. Uživatelem může být pouze osoba starší
                        16 let. Správcem osobních údajů souvisejících s
                        uživatelským účtěm je ve smyslu nařízení GDPR
                        Provozovatel.
                    </dd>

                    <dt>Pořadatel</dt>
                    <dd>
                        je Uživatel aplikace xathlo.com, který má s
                        provozovatelem uzavřeným zvláštní smluvní vztah a
                        aplikaci xathlo.com používá při organizaci závodů nebo
                        podobných sportovních akcí
                    </dd>

                    <dt>Závodník</dt>
                    <dd>
                        fyzická osoba, k níž se osobní údaje vztahují v rámci
                        konkrétního závodu organizovaného Pořadatelem. Správcem
                        osobních údajů závodníka je ve smyslu nařízení GDPR vždy
                        Pořadatel závodu. Provozovatel je ve v tomto smyslu
                        zpracovatelem dat.
                    </dd>
                </dl>

                {/*<Typography variant={"h5"}>*/}
                {/*    Zpracovávané osobní údaje*/}
                {/*</Typography>*/}
                {/*ktera data, za jakym ucelem + jak dlouho*/}
                {/*data uzivatelu*/}
                {/*email, jmeno*, nic verejne/}
                // data zavodniku
                // do systemu se dostatnete registraci online, nebo na miste
                // jmeno, rok narozeni, email - neverejne,
                {/* zavodnici mladsi 16 let se souhlasem zakonneho zastupce</Typography>*/}

                <Typography variant={"h5"}>
                    Jak získat přístup k vašim osobním údajům a jak je
                    spravovat?
                </Typography>
                <Typography gutterBottom>
                    obracejte se na email <Email email={"hello@xathlo.com"} />.
                    Pokud nejsou požadovaná data spojena s uživatelským účtem,
                    vyhrazujeme si právo přiměřeným způsobem ověřit identitu
                    žadatele o předmětná práva.
                </Typography>

                <Typography variant={"h5"}>
                    Monitoring chování uživatelů pomocí služby Microsoft Clarity
                </Typography>

                <Typography gutterBottom>
                    Používáme službu Microsoft Clarity pro analýzu chování
                    uživatelů, kterou nabízí společnost Microsoft Corporation
                    (&quot;Microsoft&quot;). Tato služba nám pomáhá pochopit,
                    jak návštěvníci interagují s našimi webovými stránkami, a to
                    prostřednictvím zaznamenávání anonymních údajů. Tyto údaje
                    neidentifikují jednotlivé uživatele a slouží pouze ke
                    zlepšení celkové použitelnosti a uživatelského komfortu
                    našich webových stránek.
                </Typography>
                <Typography>
                    Údaje shromážděné společností Microsoft mohou zahrnovat:
                </Typography>
                <ul>
                    <li>kliknutí a pohyby myši</li>
                    <li>scrollování stránky</li>
                    <li>
                        zobrazení stránky a čas strávený na jednotlivých
                        stránkách
                    </li>
                    <li>typ zařízení a operační systém</li>
                </ul>
                <Typography gutterBottom>
                    Další informace o tom, jak společnost Microsoft shromažďuje
                    a používá vaše údaje, naleznete v{" "}
                    <ExternalLink
                        href={
                            "https://privacy.microsoft.com/cs-CZ/privacystatement"
                        }
                    >
                        Prohlášení o ochraně osobních údajů společnosti
                        Microsoft.
                    </ExternalLink>
                </Typography>
                <Typography>
                    Používáním našich webových stránek souhlasíte se
                    shromažďováním a zpracováním vašich údajů společností
                    Microsoft způsobem a pro účely popsané výše.
                </Typography>
            </Container>
        </Layout>
    );
};
